import React from 'react'
import { connect } from 'react-redux'
import { fetchWorkSummaries } from '../../actions/remote_api'
import WorkSummaryListView from './WorkSummaryListView'
import { isEmpty, debounce } from 'lodash'
import BackButton from '../../components/BackButton'
import { toastr } from 'react-redux-toastr'

class WorkSummaryListViewContainer extends React.Component {
  state = {
    searchText: '',
  }

  isLoading = false

  constructor(props) {
    super(props)
    this.search = debounce(this.search, 300)
  }

  componentDidMount() {
    this.search()
  }

  handleSearchTextChange = (e) => {
    this.setState(
      {
        searchText: e.target.value,
      },
      this.search,
    )
  }

  search = () => {
    const query = { daily: true, summaryReport: true }
    if (!isEmpty(this.state.searchText)) {
      query.q = this.state.searchText
    }
    toastr.info('Loading')
    this.isLoading = true
    this.props.fetchWorkSummaries(query)
  }

  componentDidUpdate(prevProps) {
    if (
      this.isLoading &&
      prevProps.workSummaries !== this.props.workSummaries &&
      this.props.workSummaries !== undefined
    ) {
      this.isLoading = false
      toastr.success('Load completed')
    }
  }

  render() {
    return (
      <div className="h-full flex flex-col">
        <div className="w-full mb-4">
          <div className="flex items-center gap-3 mb-3">
            <BackButton onClick={this.props.onBack}>Back</BackButton>
            <h1 className="text-3xl font-semibold text-gray-900">
              Work Summary
            </h1>
          </div>
          <div className="border-t border-gray-200"></div>
        </div>
        <div className="flex-1 overflow-hidden">
          <WorkSummaryListView
            workSummaries={this.props.workSummaries}
            onWorkSummaryClick={this.props.onWorkSummaryClick}
            searchText={this.state.searchText}
            onSearchTextChange={this.handleSearchTextChange}
          />
        </div>
      </div>
    )
  }
}

export default connect(
  ({ fetch }) => ({
    workSummaries: fetch.workSummary ? fetch.workSummary.list : undefined,
  }),
  { fetchWorkSummaries },
)(WorkSummaryListViewContainer)
